<div *ngIf="data?.length; else noData">
	<canvas
		baseChart
		[data]="barChartData"
		[options]="barChartOptions"
		[type]="barChartType"
		width="600"
		height="400"
	>
	</canvas>
</div>

<ng-template #noData>
	<div class="empty-state">Data not available</div>
</ng-template>
